import { GlobalStoreContextType } from "../context/GlobalStoreContext";
import { HaulRouteModel } from "./HaulRoute.model";
import { MapObject } from "./MapObject";

export class HaulRoute extends HaulRouteModel {
    static fromFeature(feature: GeoJSON.Feature, project: any, timezone: string): HaulRoute {
        return HaulRoute.fromApiObject(
            {
                id: null,
                project_id: project.id,
            },
            timezone
        );
    }

    getMapObject(globalStoreContext: GlobalStoreContextType): MapObject | null {
        const projectMapObjects = globalStoreContext.mapObjectsForProject(this.projectId || "");

        const mapObject = projectMapObjects.find(
            (mapObject) => mapObject.mappableType == "HaulRoute" && mapObject.mappableId == this.id
        );

        if (mapObject) {
            return mapObject;
        }

        return null;
    }
}
